module.exports = __webpack_public_path__ + "static/media/PATS_5-1267w.7514bab2.png";